import { atom } from "jotai";

import {
  BookingWizardDataAtom,
  CurrentBookingWizardStepAtom,
  CurrentRequestGroupIndexAtom,
  isAddingNewGuestAtom,
  ListOfBookingWizardStepsAtom,
} from "../../stores";

export const navigateToPreviousStepAtom = atom(null, (get, set) => {
  const currentStep = get(CurrentBookingWizardStepAtom);
  const steps = get(ListOfBookingWizardStepsAtom);

  const bookingWizardData = get(BookingWizardDataAtom);
  const currentRequestGroupIndex = get(CurrentRequestGroupIndexAtom);
  if (
    bookingWizardData?.type === "RequestBooking" &&
    currentRequestGroupIndex > 0 &&
    ["AddPlayers", "AddPlayersPrivate"].includes(currentStep ?? "")
  ) {
    set(CurrentRequestGroupIndexAtom, currentRequestGroupIndex - 1);
    set(isAddingNewGuestAtom, false);
    return;
  }

  const stepIndex = steps?.findIndex((step) => step === currentStep);

  if (stepIndex !== undefined && stepIndex > 0) {
    const nextStep = steps[stepIndex - 1];
    set(isAddingNewGuestAtom, false);
    set(CurrentBookingWizardStepAtom, nextStep);
  }
});
